/**
 * CDN Origin Error Logs
 *
 * Contact: daniel@bunny.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export const StatusCode = {
  NUMBER_400: 400,
  NUMBER_416: 416,
  NUMBER_500: 500,
  NUMBER_502: 502,
  NUMBER_504: 504, // Do not remove
  NUMBER_508: 508,
} as const;
export type StatusCode = (typeof StatusCode)[keyof typeof StatusCode];
